var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2254 2.83438C25.0798 2.2862 24.7928 1.78589 24.3931 1.38354C23.9933 0.981204 23.4948 0.690984 22.9476 0.541901C20.9384 6.55651e-07 12.8818 0 12.8818 0C12.8818 0 4.8253 6.55651e-07 2.8161 0.541901C2.26887 0.690984 1.77042 0.981204 1.37066 1.38354C0.970898 1.78589 0.683859 2.2862 0.538299 2.83438C-0.179433 6.9644 -0.179433 11.1873 0.538299 15.3173C0.683853 15.8655 0.970883 16.3658 1.37064 16.7682C1.7704 17.1705 2.26886 17.4608 2.8161 17.6099C4.8253 18.1517 12.8818 18.1517 12.8818 18.1517C12.8818 18.1517 20.9384 18.1517 22.9476 17.6099C23.4948 17.4608 23.9933 17.1705 24.3931 16.7682C24.7928 16.3658 25.0798 15.8655 25.2254 15.3173C25.9433 11.1873 25.9433 6.96439 25.2254 2.83438ZM10.2469 12.9064V5.245L16.9807 9.07578L10.2469 12.9064Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube2);
export default __webpack_public_path__ + "static/media/Youtube 2.485f892685554e7437dbb55561d97a76.svg";
export { ForwardRef as ReactComponent };